/* Hang Dry: product photo viewer, plus play-on-scroll for product videos. Click a photo or video in the product
   page grid, or a piece hanging on the line, to see it full screen (videos play there). The photo fills the panel width; scroll inside it to see the rest. Arrows (and arrow keys, or a swipe on phones) step through the set: the front piece on the line
   first, then the photo grid. The back view on the line is not in the set; clicking it opens the front.
   Product videos skip their first second (an empty opening frame) and stay hidden until they are actually
   moving, so no still cover frame ever shows; they loop back to that same point.
   Esc, the X or a click on the empty space closes it. */
(function () {
  var VIDEO_START = 1; // seconds skipped at the start of every product video
  var root, img, vid, stage, prev, next, items = [], idx = 0, lastFocus;
  var ICON = {
    prev: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4 6.5 10l6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
  };
  var FRONT_SEL = '.hd-pdp-line .hd-pdp-line__piece:not(.hd-pdp-line__piece--back) .hd-hang__garment';

  // Shared video handling: no cover frame, hidden until moving, skip the opening, loop to the same point
  function startAt(v) { var d = v.duration; return (d && isFinite(d) && d > VIDEO_START * 3) ? VIDEO_START : 0; }
  function prep(v) {
    if (v.__hdPrep) return;
    v.__hdPrep = true;
    v.removeAttribute('poster');
    v.loop = false;
    v.removeAttribute('loop');
    v.style.transition = 'opacity .25s ease';
    v.style.opacity = '0';
    v.addEventListener('loadedmetadata', function () { if (v.currentTime < startAt(v)) { try { v.currentTime = startAt(v); } catch (e) {} } });
    v.addEventListener('timeupdate', function () { if (v.currentTime >= startAt(v) && v.currentTime > 0) v.style.opacity = '1'; });
    v.addEventListener('ended', function () { try { v.currentTime = startAt(v); } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  }
  function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function key(u) { try { return new URL(u, location.href).pathname; } catch (e) { return (u || '').split('?')[0]; } }
  function largest(el) {
    var ss = el.getAttribute('srcset');
    if (ss) {
      var best = ss.split(',').map(function (s) { return s.trim().split(/\s+/); })
        .sort(function (a, b) { return parseInt(b[1], 10) - parseInt(a[1], 10); })[0];
      if (best && best[0]) return best[0];
    }
    return el.currentSrc || el.src;
  }
  function collect() {
    items = [];
    var seen = {};
    function add(src, alt, el, video) {
      var k = key(src);
      if (!src || seen[k] != null) { if (seen[k] != null) items[seen[k]].els.push(el); return; }
      seen[k] = items.length;
      items.push({ src: src, alt: alt || '', els: [el], video: video });
    }
    document.querySelectorAll(FRONT_SEL).forEach(function (g) {
      var i = g.querySelector('.hd-hang__img');
      add(g.getAttribute('data-lb-src') || g.getAttribute('data-probe'), i && i.alt, g);
    });
    document.querySelectorAll('.hd2-pdp-gallery .hd2-media img, .hd2-pdp-gallery .hd2-media video').forEach(function (i) {
      if (i.tagName === 'VIDEO') {
        var srcs = [].map.call(i.querySelectorAll('source'), function (s) { return { src: s.src, type: s.type }; });
        if (!srcs.length && i.currentSrc) srcs = [{ src: i.currentSrc, type: '' }];
        if (srcs.length) add(srcs[0].src, '', i, { sources: srcs, el: i });
      } else add(largest(i), i.alt, i);
    });
  }
  function build() {
    root = document.createElement('div');
    root.className = 'hd-lb';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product photos');
    root.innerHTML = '<div class="hd-lb__stage"><img class="hd-lb__img" alt=""><video class="hd-lb__img hd-lb__vid" muted playsinline autoplay preload="auto" hidden></video></div>' +
      '<button type="button" class="hd-lb__btn hd-lb__prev" aria-label="Previous photo">' + ICON.prev + '</button>' +
      '<button type="button" class="hd-lb__btn hd-lb__next" aria-label="Next photo">' + ICON.next + '</button>' +
      '<button type="button" class="hd-lb__btn hd-lb__close" aria-label="Close">' + ICON.close + '</button>';
    document.body.appendChild(root);
    img = root.querySelector('img.hd-lb__img');
    vid = root.querySelector('.hd-lb__vid');
    vid.muted = true;
    vid.setAttribute('muted', '');
    prep(vid);
    stage = root.querySelector('.hd-lb__stage');
    prev = root.querySelector('.hd-lb__prev');
    next = root.querySelector('.hd-lb__next');
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    root.querySelector('.hd-lb__close').addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    // A tap on the video starts it if the phone held it back
    vid.addEventListener('click', function () { if (vid.paused) play(vid); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      x0 = null;
    });
  }
  function show() {
    var it = items[idx];
    if (it.video) {
      img.hidden = true;
      vid.hidden = false;
      var g = it.video.el;
      var src = (g && g.currentSrc) || it.video.sources[0].src;
      var at = (g && !isNaN(g.currentTime)) ? g.currentTime : 0;
      vid.style.opacity = '0';
      if (vid.getAttribute('src') !== src) { vid.src = src; vid.load(); }
      var seek = function () { try { vid.currentTime = Math.max(at, startAt(vid)); } catch (e) {} };
      if (vid.readyState >= 1) seek(); else vid.addEventListener('loadedmetadata', seek, { once: true });
      play(vid);
    } else {
      vid.pause();
      vid.hidden = true;
      img.hidden = false;
      img.src = it.src;
      img.alt = it.alt;
    }
    var many = items.length > 1;
    prev.hidden = next.hidden = !many;
    stage.scrollTop = 0;
    [1, -1].forEach(function (d) { var n = items[(idx + d + items.length) % items.length]; if (n && !n.video) (new Image()).src = n.src; });
  }
  function step(d) { if (items.length < 2) return; idx = (idx + d + items.length) % items.length; show(); }
  function open(el) {
    collect();
    if (!items.length) return;
    idx = 0;
    items.forEach(function (it, i) { if (it.els.indexOf(el) > -1) idx = i; });
    if (!root) build();
    lastFocus = document.activeElement;
    show();
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    root.querySelector('.hd-lb__close').focus();
  }
  function close() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    if (vid) vid.pause();
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.hd-pdp-line .hd-hang__garment, .hd2-pdp-gallery .hd2-media img, .hd2-pdp-gallery .hd2-media video');
    if (!t) return;
    e.preventDefault();
    // The back view opens the front
    if (t.closest('.hd-pdp-line__piece--back')) t = document.querySelector(FRONT_SEL) || t;
    open(t);
  });
  // Product videos in the grid: play once scrolled into view, pause when scrolled away
  function watchVideos() {
    var vids = document.querySelectorAll('video[data-hd-autoplay]');
    if (!vids.length) return;
    vids.forEach(prep);
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.preload = 'auto'; play(v); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; play(v); } else v.pause();
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchVideos); else watchVideos();
  document.addEventListener('keydown', function (e) {
    if (!root || !root.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
    else if (e.key === 'Tab') {
      var f = [].slice.call(root.querySelectorAll('button:not([hidden])'));
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  });
})();
